import type { ImpersonateLogsListParams } from '../../types/pages'

export const DEFAULT_IMPERSONATE_LOGS_PARAMS: ImpersonateLogsListParams = {
  page: 1,
  perPage: 15,
  sortBy: 'desc',
  orderBy: 'created_at',
  q: '',
  fromDt: '',
  toDt: '',
}
